export default __webpack_public_path__ + "static/media/158ccbff9a2039f9.a930ae3c37061cd60a6427f3902d1756.svg";